import React from 'react';
import styled from 'styled-components';
import WidthWrapper from './WidthWrapper';
import Heading from './Heading';
import Button from './Button';

const StyledWebinarHero = styled.section`
  display: flex;
  background-color: var(--primary);
  width: 100%;
  max-height: 35rem;
  height: fit-content;
  color: var(--white);

  .width-wrapper {
    padding: 5rem 2rem 4.375rem;
    margin: 0 0 0 auto;
    width: 50%;
    max-width: 37.4375rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  a {
    text-transform: uppercase;
  }

  img {
    width: 50%;
    object-fit: cover;
  }

  .webinar-info {
    display: flex;
    margin-bottom: 3.0625rem;
  }

  .webinar-info div {
    padding: 1.5rem 1rem;
    border: 1px solid var(--white);
    max-width: 14.4375rem;
    width: 50%;
    display: flex;
    justify-content: center;
  }

  @media only screen and (max-width: 850px) {
    flex-direction: column;
    max-height: none;

    img,
    .width-wrapper {
      width: 100%;
      max-width: none;
    }

    img {
      height: 32.25rem;
    }

    .width-wrapper {
      margin: 0;
      padding: 3.5 2rem 3.75rem;
      height: fit-content;
    }
  }

  @media only screen and (max-width: 500px) {
    .webinar-info {
      flex-direction: column;
    }

    .webinar-info div {
      max-width: none;
      width: 100%;
    }

    .button-wrapper {
      display: flex;
      justify-content: center;
    }
  }
`;

const WebinarHero = ({ headingText, register, date, time, img, video, unformattedDate }) => {
  return (
    <StyledWebinarHero>
      <WidthWrapper>
        <Heading browText="Webinar" headingLevel={3} headingText={headingText} orange leftAligned />
        <div className="webinar-info body-l-semibold">
          <div>{date}</div>
          <div>{time}</div>
        </div>
        <div className="button-wrapper">
          {video ? (
            <Button text="Watch" link={video} secondary />
          ) : new Date(unformattedDate) >= new Date() ? (
            <Button text="Register" link={register} secondary />
          ) : (
            <p>Video coming soon</p>
          )}
        </div>
      </WidthWrapper>
      <img src={img} alt="webinar hero" />
    </StyledWebinarHero>
  );
};

export default WebinarHero;
